import { render, staticRenderFns } from "./ChangePhonesPopup.vue?vue&type=template&id=98c928f4"
import script from "./ChangePhonesPopup.vue?vue&type=script&lang=js"
export * from "./ChangePhonesPopup.vue?vue&type=script&lang=js"
import style0 from "./ChangePhonesPopup.vue?vue&type=style&index=0&id=98c928f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports